module.exports = __webpack_public_path__ + "static/img/AR.fdd3b1a4.svg";